import { Controller } from "@hotwired/stimulus"
import * as CookieConsent from "vanilla-cookieconsent"

export default class extends Controller {
  static values = { privacy: Boolean }

  connect() {
    this.setupCookie()
  }

  disconnect() {
    // if (this.privacyValue) {
    if (!CookieConsent.validConsent()) {
      CookieConsent.reset()
    }
  }

  acceptedCategory(category) {
    return CookieConsent.acceptedCategory(category)
  }

  showPreferences(event) {
    event.preventDefault()
    CookieConsent.showPreferences()
  }

  setupCookie() {
    CookieConsent.run({

      autoShow: !this.privacyValue,
      disablePageInteraction: !this.privacyValue,
      // lazyHtmlGeneration: false,

      onModalShow: ({modalName}) => {
        const modal = document.getElementById("cc-main")
        if (modal && modal.hasAttribute("data-cookieconsent")) {
          modal.remove()
        }
        const modal_load = document.getElementById("cc-main")
        if (modal_load) {
          modal_load.setAttribute("data-turbo-permanent", "true")
        }
      },

      cookie: {
        name: 'cc_cookie',
        domain: window.location.hostname,
        path: '/',
        secure: true,
        expiresAfterDays: 182,
        sameSite: 'Strict',
        useLocalStorage: false
      },

      categories: {
        necessary: {
          enabled: true,
          readOnly: true
        },
        // functional: {
        //   enabled: true,
        // },
        analytics: {
          enabled: true,
          autoClear: {
            cookies: [
              {
                name: /^_ga/,   // regex: match all cookies starting with '_ga'
              },
              {
                name: '_gid',   // string: exact cookie name
              }
            ]
          },
        }
      },

      guiOptions: {
        consentModal: {
          layout: 'cloud inline',
          position: 'bottom right'
        }
      },

      language: {
        default: 'en',
        autoDetect: 'document',
        translations: {
          en: {
            consentModal: {
              title: 'We use cookies',
              description: 'We use cookies to improve your experience<br /><a href="/en/privacy">Privacy</a> - <a href="/en/terms">Terms & Conditions</a>',
              acceptAllBtn: 'Accept all',
              acceptNecessaryBtn: 'Reject all',
              showPreferencesBtn: 'Manage preferences',
              // footer: `
              //   <a href="/en/privacy">Privacy</a>
              // `
            },
            preferencesModal: {
              title: 'Manage cookie preferences',
              acceptAllBtn: 'Accept all',
              acceptNecessaryBtn: 'Reject all',
              savePreferencesBtn: 'Accept current selection',
              closeIconLabel: 'Close modal',
              sections: [
                {
                  title: 'Somebody said ... cookies?',
                  description: 'I want one!'
                },
                {
                  title: 'Necessary',
                  description: 'These cookies are essential for the proper functioning of the website and cannot be disabled. Also includes displaying maps with OpenStreetMap.',

                  linkedCategory: 'necessary'
                },
                // {
                //   title: 'Functional cookies and Maps',
                //   description: 'These cookies and integrations improve your experience, this enables displaying maps with OpenStreetMap.',

                //   linkedCategory: 'functional'
                // },
                {
                  title: 'Performance and Analytics',
                  description: 'These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.',
                  linkedCategory: 'analytics',
                  cookieTable: {
                    caption: 'Cookie table',
                    headers: {
                      name: 'Cookie',
                      domain: 'Domain',
                      desc: 'Description'
                    },
                    body: [
                      {
                        name: '_ga',
                        domain: location.hostname,
                        desc: 'Google Analytics',
                      },
                      {
                        name: '_gid',
                        domain: location.hostname,
                        desc: 'Google Analytics'
                      }
                    ]
                  }
                },
                {
                  title: 'More information',
                  description: 'Please find more information on <a href="/en/privacy">Privacy</a> and <a href="/fr/terms">Terms & conditions</a>'
                }
              ]
            }
          },
          fr: {
            consentModal: {
              title: 'Nous utilisons des cookies',
              description: 'Nous utilisons des cookies pour améliorer votre expérience<br /><a href="/fr/privacy">Politique de confidentialité</a> - <a href="/fr/terms">Conditions générales</a>',
              acceptAllBtn: 'Accepter',
              acceptNecessaryBtn: 'Refuser',
              showPreferencesBtn: 'Modifier mes préférences',
              // footer: `
              //   <a href="/fr/privacy">Privacy</a>
              // `
            },
            preferencesModal: {
              title: 'Modifier mes préférences',
              acceptAllBtn: 'Accepter tous',
              acceptNecessaryBtn: 'Refuser',
              savePreferencesBtn: 'Accepter la sélection',
              closeIconLabel: 'Fermer',
              sections: [
                {
                  title: 'Des ... cookies?',
                  description: 'J\'en veux!'
                },
                {
                  title: 'Nécessaire',
                  description: 'Ces cookies sont essentiels pour le fonctionnement du site et ne peuvent être désactivés. Inclus également l\'affichage des cartes avec OpenStreetMap.',

                  linkedCategory: 'necessary'
                },
                // {
                //   title: 'Functional cookies and Maps',
                //   description: 'These cookies and integrations improve your experience, this enables displaying maps with OpenStreetMap.',

                //   linkedCategory: 'functional'
                // },
                {
                  title: 'Analytiques',
                  description: 'Ces cookies collecte des informations à propos de votre utilisation sur le site. Toutes les données sont anonymisées et ne peuvent être utilisées pour vous identifier.',
                  linkedCategory: 'analytics',
                  cookieTable: {
                    caption: 'Tableau des Cookies',
                    headers: {
                      name: 'Cookie',
                      domain: 'Domaine',
                      desc: 'Description'
                    },
                    body: [
                      {
                        name: '_ga',
                        domain: location.hostname,
                        desc: 'Google Analytics',
                      },
                      {
                        name: '_gid',
                        domain: location.hostname,
                        desc: 'Google Analytics'
                      }
                    ]
                  }
                },
                {
                  title: 'Plus d\'informations',
                  description: 'Veuillez trouver plus d\'informations sur <a href="/fr/privacy">Politique de confidentialité</a> et <a href="/fr/terms">Conditions générales</a>'
                }
              ]
            }
          },
          nl: {
            consentModal: {
              title: 'Wij gebruiken cookies',
              description: 'We gebruiken cookies om uw ervaring te verbeteren<br /><a href="/nl/privacy">Privacy</a> - <a href="/nl/terms">Algemene voorwaarden</a>',
              acceptAllBtn: 'Alles accepteren',
              acceptNecessaryBtn: 'Alles afwijzen',
              showPreferencesBtn: 'Cookies instellingen',
              // footer: `
              //   <a href="/en/privacy">Privacy</a>
              // `
            },
            preferencesModal: {
              title: 'Cookievoorkeuren beheren',
              acceptAllBtn: 'Alles accepteren',
              acceptNecessaryBtn: 'Alles afwijzen',
              savePreferencesBtn: 'Accepteer de huidige selectie',
              closeIconLabel: 'Sluiten',
              sections: [
                {
                  title: '... cookies?',
                  description: 'Ik wil er één!'
                },
                {
                  title: 'Nodig',
                  description: 'Deze cookies zijn essentieel voor de goede werking van de website en kunnen niet worden uitgeschakeld. Omvat ook het weergeven van kaarten met OpenStreetMap.',

                  linkedCategory: 'necessary'
                },
                // {
                //   title: 'Functional cookies and Maps',
                //   description: 'These cookies and integrations improve your experience, this enables displaying maps with OpenStreetMap.',

                //   linkedCategory: 'functional'
                // },
                {
                  title: 'Analytische',
                  description: 'Deze cookies verzamelen informatie over hoe u onze website gebruikt. Alle gegevens worden geanonimiseerd en kunnen niet worden gebruikt om u te identificeren.',
                  linkedCategory: 'analytics',
                  cookieTable: {
                    caption: 'Cookie lijst',
                    headers: {
                      name: 'Cookie',
                      domain: 'Domein',
                      desc: 'Description'
                    },
                    body: [
                      {
                        name: '_ga',
                        domain: location.hostname,
                        desc: 'Google Analytics',
                      },
                      {
                        name: '_gid',
                        domain: location.hostname,
                        desc: 'Google Analytics'
                      }
                    ]
                  }
                },
                {
                  title: 'Meer informatie',
                  description: 'Meer informatie vindt u op <a href="/nl/privacy">Privacy</a> and <a href="/nl/terms">Algemene voorwaarden</a>'
                }
              ]
            }
          }
        }
      }
    })
  }
}
